module.exports = __webpack_public_path__ + "img/sparkling.45384bb0.gif";